import { connect } from 'react-redux';
import { buildURL } from 'Shared/fetch';

import { useAuthPopup } from '@/components/SocialLoginBar/AuthPopupContext';
import checkLocalStorageForODTP from '@/helpers/checkLocalStorageForODTP';
import getDeviceId from '@/helpers/getDeviceId';

import apple from './logos/apple.svg';
import facebook from './logos/facebook.svg';
import google from './logos/google.svg';
import style from './style.scss';

const SocialLoginButton = ({ variant, referralData }) => {
  const deviceId = getDeviceId();
  // Absent outside the Speedy Flow, where navigating the page away is the right behaviour.
  const authPopup = useAuthPopup();

  if (!['facebook', 'google', 'apple'].includes(variant)) {
    return null;
  }

  const queryParams = new URLSearchParams();
  if (deviceId) {
    queryParams.append('deviceId', deviceId);
  }

  if (referralData) {
    // in case we are going to append any patameter here (whether it is a new referralData param
    // or a new custom param ), we shouldn't forget to
    // add it to the socialMediaLogin function on our API as well
    Object.entries(referralData).forEach(([key, value]) => {
      if (value) {
        queryParams.append(key, value);
      }
    });
  }
  queryParams.append('platform', variant);

  // for Preact frontEndPlatform is 'webApp' and for Native-app it is 'ios' or 'android:
  queryParams.append('frontEndPlatform', 'webApp');

  // Anything the surrounding flow needs back after the provider round trip.
  Object.entries(authPopup?.params ?? {}).forEach(([key, value]) => {
    if (value) {
      queryParams.append(key, value);
    }
  });

  const origin = window.location.pathname;
  queryParams.append('origin', origin);

  const { userAgent } = navigator;
  queryParams.append('userAgent', userAgent);

  const { searchParams } = new URL(document.location);
  const plan = searchParams.get('plan');
  const price = searchParams.get('price');
  let odtpParam = searchParams.get('odtp');
  if (plan && price) {
    queryParams.append('plan', plan);
    queryParams.append('price', price);
  }
  if (odtpParam) {
    odtpParam = checkLocalStorageForODTP(odtpParam);
    if (odtpParam) {
      queryParams.append('odtp', odtpParam);
    }
  }

  const handleClick = () => {
    const url = buildURL('connect', variant, `?${queryParams}`);
    // Opened during the click, so the browser treats it as a user gesture rather than a popup.
    if (authPopup?.open(url)) {
      return;
    }
    window.location.href = url;
  };

  return (
    <a
      data-native
      href={buildURL('connect', variant, `?${queryParams}`)}
      rel="noopener noreferrer nofollow"
      data-platform={variant}
      data-component="social-login-button"
      className={style.socialButton}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        handleClick();
      }}
    >
      {variant === 'facebook' && <img src={facebook} alt={`Social Login using ${variant}`} />}
      {variant === 'google' && <img src={google} alt={`Social Login using ${variant}`} />}
      {variant === 'apple' && <img src={apple} alt={`Social Login using ${variant}`} />}
      <span>{variant}</span>
    </a>
  );
};

export default connect(({ user: { referralData } }) => ({
  referralData,
}))(SocialLoginButton);
